import React, { useReducer } from 'react';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';

import { publicationRegisterStore } from '@stores/publicationRegisterStore';
import { addZeroToDate } from '@utils';

import styles from '../PublicationRegisterDrawer.module.scss';

export const Calendar = observer(() => {
  const [calendarOpen, toggleCalendar] = useReducer((state) => !state, false);
  const { reportPackageInfo } = publicationRegisterStore;

  return (
    <>
      <p className={styles.calendarTitle}>Календарь</p>
      <div className={cm(styles.calendar, { [styles.open]: calendarOpen })}>
        <div className={styles.calendarHeader}>
          <p className={styles.text}>
            {calendarOpen ? (
              <>
                Периодичность:{' '}
                <span>
                  {reportPackageInfo.frequencyCode} - {reportPackageInfo.frequencyName}
                </span>
              </>
            ) : (
              ''
            )}
          </p>

          <div onClick={toggleCalendar} className={styles.arrow}>
            <Icon name="expandArrow" fill={calendarOpen ? '#547DB1' : '#9EB3C8'} />
          </div>
        </div>

        <div className={styles.calendarBody}>
          {reportPackageInfo.calendar?.map((item, index) => (
            <div key={index}>
              <p className={styles.text}>
                Дата подачи отчетности:{' '}
                <span>{`${addZeroToDate(item.preparationDay)}.${addZeroToDate(item.preparationMonthCode)}`}</span>
              </p>
              <p className={styles.text}>
                Дата раскрытия отчетности:{' '}
                <span>{`${addZeroToDate(item.dueDay)}.${addZeroToDate(item.disclosureMonthCode)}`}</span>
              </p>
              <p className={styles.text}>
                Наименование периода: <span>{item.periodName}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
});
